import { Box, Grid, Typography, useTheme } from "@mui/material"
import Header from "components/Header/Header"
import { createBreadcrumbs } from "helpers/breadCrumbs"
import React, { useEffect, useRef, useState } from "react"
import styles from "./hotel-config.module.scss"
import SortingToggleIcon from "assets/icons/SortingToggleIcon.svg"
import { Create } from "@mui/icons-material"
import AppButton from "components/StyledComponents/AppButton"
import Plus from "assets/icons/Plus.svg"
import trashIcon from "assets/icons/trash.svg"
import DeleteConfirmationDialog from "components/DeleteConfirmationDialog"
import HotelCategoryModal from "./component/categoryModal"
import { useDispatch, useSelector } from "react-redux"
import {
  addDynamicFieldsAction,
  changeCategoryOrderAction,
  deleteHotelCategoryAction,
  getDynamicFieldsAction,
  getHotelCategoryListAction
} from "redux/hotel/action"
import DynamicFieldModal from "./component/dynamicFieldModal"
import ToggleSwitch from "components/StyledComponents/ToggleSwitch"
import { toast } from "react-toastify"
import ChevronRightIcon from "@mui/icons-material/ChevronRight"
import ArrowBackIcon from "@mui/icons-material/ArrowBack"

const HotelConfiguration = () => {
  const [breadCrumbs, setBreadCrumbs] = useState("")
  const [isEdit, setIsEdit] = useState(false)
  const [categoryModal, setCategoryModal] = useState(false)
  const { hotelCategoryList, hotelID, dynamicFieldsGroup } = useSelector((store) => store?.hotel)
  const [deleteModal, setDeleteModal] = useState(false)
  const [newField, setNewField] = useState(false)
  const [selectedCategoryId, setSelectedCategoryId] = useState("")
  const [fieldId, setfieldId] = useState("")
  const [deleteType, setDeleteType] = useState("")
  const [fieldData, setFieldData] = useState({})
  const [isGroup, setIsGroup] = useState(true)
  const [currentGroup, setCurrentGroup] = useState({})
  const [draggedIndex, setDraggedIndex] = useState(null)
  const [selectedHotelCategory, setSelectedHotelCategory] = useState("")
  const preserveSelectionRef = useRef(false)
  const { isLoading } = useSelector((store) => store.app)
  const theme = useTheme()
  const dispatch = useDispatch()

  const isEditableGroup =
    currentGroup?.key !== "common" &&
    !["daily_hours", "week_time_range"].includes(currentGroup?.type)

  const shouldShowButtonForChef = !(
    currentGroup?.key?.toLowerCase().includes("chef") && currentGroup?.fields.length === 2
  )

  const handleEdit = () => {
    preserveSelectionRef.current = true
    setIsEdit(true)
    setCategoryModal(true)
  }

  const handleEditField = (item) => {
    setIsEdit(true)
    setNewField(true)
    setFieldData(item)
  }

  const handleGroup = (item) => {
    setIsGroup(false)
    setCurrentGroup(item)
  }

  const handleClose = () => {
    setIsEdit(false)
    setCategoryModal(false)
  }

  const handleCloseFieldModal = () => {
    setIsEdit(false)
    setNewField(false)
  }

  function handleCloseModal() {
    setDeleteModal(false)
  }

  const handleDelete = (id, type) => {
    setfieldId(id)
    setDeleteType(type)
    setDeleteModal(true)
  }

  const handleDeleteField = () => {
    if (deleteType === "field") {
      let updatedFieldsList = dynamicFieldsGroup?.map((group) =>
        group.key === currentGroup?.key
          ? { ...group, fields: group?.fields?.filter((item) => item.key !== fieldId) }
          : group
      )
      updatedFieldsList = updatedFieldsList?.filter((group) => group?.key !== "common")
      dispatch(
        addDynamicFieldsAction({
          payload: { dynamic_fields: updatedFieldsList, action: "delete" },
          onClose: () => setDeleteModal(false),
          id: selectedCategoryId
        })
      )
    } else if (deleteType === "group") {
      let updatedFieldsList = dynamicFieldsGroup?.filter((group) => group.key !== fieldId)
      updatedFieldsList = updatedFieldsList.filter((group) => group?.key !== "common")
      dispatch(
        addDynamicFieldsAction({
          payload: { dynamic_fields: updatedFieldsList, action: "delete" },
          onClose: () => setDeleteModal(false),
          id: selectedCategoryId
        })
      )
    } else {
      dispatch(deleteHotelCategoryAction({ id: fieldId, setSelectedCategoryId }))
    }
  }

  function handleAddCategory() {
    setCategoryModal(true)
  }

  const handleAddField = () => {
    setNewField(true)
  }
  const handleHotelCategory = (name, id) => {
    setSelectedCategoryId(id)
    setSelectedHotelCategory(name)
    setIsGroup(true)
  }

  const handleToggleChange = (key) => {
    let updatedGroups = dynamicFieldsGroup?.map((group) => {
      let updatedFields = group.fields?.map((field) =>
        field.key === key ? { ...field, show_listing: !field.show_listing } : field
      )

      return { ...group, fields: updatedFields }
    })

    updatedGroups = updatedGroups?.filter((group) => group?.key !== "common")
    const activeCount = updatedGroups.reduce((count, group) => {
      return count + group.fields.filter((field) => field.show_listing).length
    }, 0)

    if (activeCount > 3) {
      toast.error("Only 3 fields can be active at a time", {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        theme: "dark"
      })
      return
    }

    dispatch(
      addDynamicFieldsAction({
        payload: { dynamic_fields: updatedGroups },
        id: selectedCategoryId,
        onClose: () => setDeleteModal(false)
      })
    )
  }

  const handleDragStart = (index) => setDraggedIndex(index)

  const handleDrop = (index, type, listData) => {
    if (draggedIndex === null || draggedIndex === index) return

    if (type === "group" && (draggedIndex === 0 || index === 0)) return

    const updatedOrder = [...listData]
    const [draggedItem] = updatedOrder.splice(draggedIndex, 1)
    updatedOrder.splice(index, 0, draggedItem)
    setDraggedIndex(null)

    if (type === "category") {
      const payload = {
        hotel: hotelID,
        configuration_order: updatedOrder?.map((item) => item?.id)
      }
      dispatch(changeCategoryOrderAction(payload))
    } else if (type === "group") {
      const filteredOrder = updatedOrder.slice(1)
      dispatch(
        addDynamicFieldsAction({
          payload: { dynamic_fields: filteredOrder, action: "reorder" },
          id: selectedCategoryId,
          onClose: () => setDeleteModal(false)
        })
      )
    } else {
      const updatedGroup = {
        ...currentGroup,
        fields: updatedOrder
      }

      const updatedDynamicFieldsGroup = dynamicFieldsGroup?.map((group) => {
        if (group.key === currentGroup.key) {
          return updatedGroup
        }
        return group
      })

      dispatch(
        addDynamicFieldsAction({
          payload: { dynamic_fields: updatedDynamicFieldsGroup?.slice(1), action: "reorder" },
          id: selectedCategoryId,
          onClose: () => setDeleteModal(false)
        })
      )
    }
  }

  useEffect(() => {
    if (selectedCategoryId) {
      dispatch(getDynamicFieldsAction(selectedCategoryId))
    }
  }, [selectedCategoryId])

  useEffect(() => {
    setCurrentGroup(dynamicFieldsGroup?.find((item) => item?.key === currentGroup?.key))
  }, [dynamicFieldsGroup])

  useEffect(() => {
    if (!hotelCategoryList?.length) return
    if (preserveSelectionRef.current) {
      const updated = hotelCategoryList.find((item) => item.id === selectedCategoryId)
      if (updated) setSelectedHotelCategory(updated.name)
      preserveSelectionRef.current = false
    } else {
      setSelectedCategoryId(hotelCategoryList[0]?.id)
      setSelectedHotelCategory(hotelCategoryList[0]?.name)
    }
  }, [hotelCategoryList])

  useEffect(() => {
    document.title = "Hotel Configuration"
    setBreadCrumbs(createBreadcrumbs())
    dispatch(getHotelCategoryListAction(hotelID))
  }, [])

  return (
    <Box className="p-2">
      <Header title={"Hotel Configuration"} breadCrumbs={breadCrumbs} />
      <Grid item container spacing={2}>
        <Grid item xs={5}>
          <Grid
            item
            sx={{ background: theme.palette.primary.main, borderRadius: "12px", padding: "24px" }}>
            <Box className="d-flex align-items-center justify-content-between">
              <Typography variant="body1Regular" sx={{ color: theme.palette.text.secondary }}>
                Select Category
              </Typography>
              <AppButton
                variant="contained"
                styles={{ padding: "10px 20px" }}
                onClick={handleAddCategory}>
                <img src={Plus} alt="add" className="flex-shrink-0 me-1" />
                <Typography>Add New Category</Typography>
              </AppButton>
            </Box>
            <Grid item mt={3}>
              {hotelCategoryList?.length > 0 ? (
                hotelCategoryList?.map((itm, index) => {
                  const isSelected = selectedCategoryId === itm?.id
                  return (
                    <Grid
                      item
                      key={itm.id}
                      className={styles.category_grid}
                      sx={{
                        backgroundColor: isSelected ? theme.palette.primary.hover : "transparent",
                        borderColor: isSelected ? "transparent" : theme.palette.secondary.main
                      }}
                      onClick={() => handleHotelCategory(itm?.name, itm?.id)}>
                      <Box
                        className="d-flex"
                        draggable
                        onDragStart={() => handleDragStart(index)}
                        onDragOver={(e) => e.preventDefault()}
                        onDrop={() => handleDrop(index, "category", hotelCategoryList)}>
                        <img
                          src={SortingToggleIcon}
                          alt="sort option"
                          className={`flex-shrink-0 me-1 ${styles.sortIcon}`}
                        />
                        <Box className={styles.categoryBox}>
                          <Typography>{itm?.name}</Typography>
                        </Box>
                        <Grid item xs={3} container justifyContent="flex-end">
                          <Box className={styles.deleteContainer}>
                            <Create onClick={handleEdit} className={styles.edit} />
                            <img
                              onClick={() => handleDelete(itm?.id, "category")}
                              style={{ cursor: "pointer" }}
                              src={trashIcon}
                              alt=""
                            />
                          </Box>
                        </Grid>
                      </Box>
                    </Grid>
                  )
                })
              ) : (
                <Typography
                  variant="h3"
                  textAlign={"center"}
                  sx={{ color: theme.palette.text.secondary }}>
                  {isLoading
                    ? "Please wait, we are fetching the categories..."
                    : "No Categories Found"}
                </Typography>
              )}
            </Grid>
          </Grid>
        </Grid>
        {isGroup ? (
          <Grid item xs={7}>
            <Grid item className={styles.arrowMenu}>
              <Grid item className={styles.arrowMenuContent}>
                <Typography variant="body1Regular">Groups</Typography>
                {dynamicFieldsGroup?.length > 0 ? (
                  dynamicFieldsGroup?.map((item, idx) => (
                    <Grid
                      item
                      xs={12}
                      container
                      justifyContent="space-between"
                      key={idx + item?.label}
                      className={styles.itemLabel}>
                      <Grid
                        item
                        draggable={idx !== 0}
                        onDragStart={() => handleDragStart(idx)}
                        onDragOver={(e) => e.preventDefault()}
                        onDrop={() => handleDrop(idx, "group", dynamicFieldsGroup)}
                        flexDirection={"row"}
                        alignItems={"center"}>
                        <img
                          src={SortingToggleIcon}
                          alt="sort option"
                          className={`flex-shrink-0 me-1 ${styles.sortIcon}`}
                          style={idx === 0 ? { visibility: "hidden" } : {}}
                        />
                        <Typography
                          variant="body1Regular"
                          sx={{ color: theme.palette.text.secondary }}>
                          {item?.label}
                        </Typography>
                      </Grid>

                      <Grid item xs={3} container justifyContent="flex-end">
                        <Box className={styles.deleteContainer}>
                          {item?.key !== "common" && (
                            <>
                              <Create
                                onClick={() => handleEditField(item)}
                                className={styles.edit}
                              />
                              <img
                                onClick={() => handleDelete(item.key, "group")}
                                style={{ cursor: "pointer" }}
                                src={trashIcon}
                                alt=""
                              />
                            </>
                          )}
                          <ChevronRightIcon
                            fontSize="medium"
                            sx={{ cursor: "pointer" }}
                            onClick={() => handleGroup(item)}
                          />
                        </Box>
                      </Grid>
                    </Grid>
                  ))
                ) : (
                  <Typography
                    variant="h3"
                    textAlign={"center"}
                    sx={{ color: theme.palette.text.secondary }}>
                    {isLoading ? "Please wait, we are fetching the groups..." : "No Groups Found"}
                  </Typography>
                )}

                {hotelCategoryList?.length ? (
                  <Grid item xs={12} mt={2}>
                    <AppButton
                      variant="contained"
                      className={styles.newFieldButton}
                      onClick={handleAddField}>
                      <img src={Plus} alt="add" className="flex-shrink-0 me-1" />
                      <Typography>Add New Groups</Typography>
                    </AppButton>
                  </Grid>
                ) : null}
              </Grid>
              <Grid item className={styles.arrow} />
            </Grid>
          </Grid>
        ) : (
          <Grid item xs={7}>
            <Grid item className={styles.arrowMenu}>
              <Grid item className={styles.arrowMenuContent}>
                <ArrowBackIcon className="me-3" onClick={() => setIsGroup(true)} />
                <Typography variant="body1Regular">{currentGroup?.label}</Typography>
                {currentGroup?.fields?.length > 0 ? (
                  currentGroup?.fields?.map((item, id) => (
                    <Grid
                      item
                      xs={12}
                      container
                      justifyContent="space-between"
                      key={id + item?.label}
                      className={styles.itemLabel}>
                      <Grid
                        item
                        draggable={
                          currentGroup.key === "common" || currentGroup.type === "daily_hours"
                            ? false
                            : true
                        }
                        onDragStart={() => handleDragStart(id)}
                        onDragOver={(e) => e.preventDefault()}
                        onDrop={() => handleDrop(id, "field", currentGroup?.fields)}
                        flexDirection={"row"}
                        alignItems={"center"}>
                        <img
                          src={SortingToggleIcon}
                          alt="sort option"
                          className={`flex-shrink-0 me-1 ${styles.sortIcon}`}
                          style={
                            currentGroup.key === "common" || currentGroup.type === "daily_hours"
                              ? { visibility: "hidden" }
                              : {}
                          }
                        />
                        <Typography
                          variant="body1Regular"
                          sx={{ color: theme.palette.text.secondary }}>
                          {item?.label}
                        </Typography>
                      </Grid>
                      {isEditableGroup && (
                        <Grid item xs={3} container justifyContent="flex-end">
                          <Box className={styles.deleteContainer}>
                            {item?.type !== "image" ? (
                              <ToggleSwitch
                                checked={item.show_listing}
                                onChange={() => handleToggleChange(item.key)}
                              />
                            ) : null}
                            <Create onClick={() => handleEditField(item)} className={styles.edit} />
                            <img
                              onClick={() => handleDelete(item.key, "field")}
                              style={{ cursor: "pointer" }}
                              src={trashIcon}
                              alt=""
                            />
                          </Box>
                        </Grid>
                      )}
                    </Grid>
                  ))
                ) : (
                  <Typography
                    variant="h3"
                    textAlign={"center"}
                    sx={{ color: theme.palette.text.secondary }}>
                    {isLoading
                      ? "Please wait, we are fetching the dynamic fields..."
                      : "No Dynamic Fields Found"}
                  </Typography>
                )}

                {isEditableGroup && shouldShowButtonForChef && (
                  <Grid item xs={12} mt={2}>
                    <AppButton
                      variant="contained"
                      className={styles.newFieldButton}
                      onClick={handleAddField}>
                      <img src={Plus} alt="add" className="flex-shrink-0 me-1" />
                      <Typography>Add New Fields</Typography>
                    </AppButton>
                  </Grid>
                )}
              </Grid>
              <Grid item className={styles.arrow} />
            </Grid>
          </Grid>
        )}
      </Grid>
      <HotelCategoryModal
        open={categoryModal}
        onClose={handleClose}
        isEdit={isEdit}
        selectedCategoryId={selectedCategoryId}
      />
      <DynamicFieldModal
        groupData={currentGroup}
        isGroup={isGroup}
        open={newField}
        onClose={handleCloseFieldModal}
        isEdit={isEdit}
        selectedCategoryId={selectedCategoryId}
        fieldData={fieldData}
        HotelCategory={selectedHotelCategory}
      />
      <DeleteConfirmationDialog
        title={`Are you sure you want to delete this ${
          deleteType === "field" ? "Field" : deleteType === "group" ? "Group" : "Category"
        }?`}
        description={" "}
        style={{ textAlign: "center" }}
        onClose={handleCloseModal}
        onDelete={() => handleDeleteField()}
        open={deleteModal}
      />
    </Box>
  )
}

export default HotelConfiguration
